import * as React from 'react';
import * as styles from './styles.css';

import { RadioButtonGroup } from '@cian/ui-kit';

import { ITabsProps } from '../types';
import { EDealType } from '../../../types/dealType';

export const MobileView = React.forwardRef<HTMLDivElement, ITabsProps>(({ tabs, dealType, onChange }, ref) => {
  return (
    <div ref={ref} data-testid="TabsMobileViewId" className={styles['container']}>
      <RadioButtonGroup
        options={tabs}
        value={dealType}
        onChange={(_, value) => onChange(value as EDealType)}
        disabled={tabs.some(tab => tab.disabled)}
      />
    </div>
  );
});

MobileView.displayName = 'MobileView';
